import { IGameState } from 'State/Game/IGameState';
import { IAPReward } from 'Utility/RewardHelper';
import { trackPurchase, trackPurchaseStatus } from 'Utility/Tracking/TrackingHelpers/Transaction';
import { PurchaseStatus } from 'Utility/Tracking/TrackingHelpers/PurchaseStatus';
import Game from 'Game';
import { PurchaseFailReason } from 'Utility/SDK/Drivers/PurchaseFailReason';
import { clearTrackingData } from 'Utility/Tracking/Track';
import { TransactionDataHandler } from 'Utility/Tracking/Handler/Transaction';
import { GameActions } from 'State/Game/GameActions';
import { ResponseStatus, ResponseType } from 'State/Game/ContextType';
import { TActionType } from 'Utility/Tracking/DataSet/Transaction';
import { GBCHandler } from '../GBCHandler';
import { hasProductBeenConsumed } from './HasProductBeenConsumed';
import { AvoTracking } from 'Utility/Tracking/Avo/AvoTracking';

export async function purchaseProduct(
    state: IGameState,
    data: {
        product: IAPReward;
        actionType?: TActionType;
    }
) {
    const productId = data.product.id;
    trackPurchaseStatus(productId, PurchaseStatus.START);

    try {
        const productPurchased = await Game.sdk.purchaseProduct(state, productId);

        // await GBCHandler.waitForGBCConnectionResolution(Game.store.getState());
        const hasAlreadyBeenConsumed = await hasProductBeenConsumed(state, productPurchased);
        // purchase was successful
        GameActions.restoreContext(ResponseStatus.SUCCESS, ResponseType.PURCHASE_PRODUCT, {
            product: data.product,
            productPurchased,
            hasAlreadyBeenConsumed,
        });
        trackPurchaseStatus(productId, PurchaseStatus.SUCCESS);
        trackPurchase(state, productId, data.product.rewards, data.actionType, productPurchased.signedRequest);
        // clearTrackingData(TransactionDataHandler);
    } catch (e) {
        const failReason: PurchaseFailReason = Object.values(PurchaseFailReason).includes(e.code)
            ? e.code
            : PurchaseFailReason.OTHER;

        trackPurchaseStatus(productId, PurchaseStatus.FAIL, failReason);
        // AvoTracking.purchaseFinished(state, productId, null, e.message);
        // clearTrackingData(TransactionDataHandler);
        // await GBCHandler.waitForGBCConnectionResolution(Game.store.getState());
        GameActions.restoreContext(ResponseStatus.FAIL, ResponseType.PURCHASE_PRODUCT, {
            errorMsg: Game.locale.getText('PurchaseFailed'),
            product: data.product,
        });
        return;
    }
}
